import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-34eca7f5"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "width": "100%",
    "height": "100%"
  }
};
const _hoisted_2 = {
  class: "content__container"
};
const _hoisted_3 = {
  class: "table__container"
};
const _hoisted_4 = {
  class: "header"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  style: {
    "margin-bottom": "15px"
  }
};
import TagType from '@/views/common/TagType/index.vue';
import Buttons from '@/components/Buttons/index.vue';
import AddOrEdit from './AddOrEdit/index.vue';
import BatchTable from './BatchTable/index.vue';
import Check from './Check/index.vue';
import SeriesLists from './SeriesLists/index.vue';
import RelevanceInfoDialog from '@/components/RelevanceInfoDialog/index.vue';
import { usePageConfig } from '@/utils/useComponentConfig';
import { getItemByProp, fileDownload, debounce } from '@/utils/tools';
import { useBrandsByUser, useVodLanguages } from '@/utils/cacheData';
import { getOperatorNameListApi, getUserByCidApi } from '@/api/authority';
import { provide, nextTick, onMounted } from 'vue';
import { elMessage } from '@/utils';
import { useI18n } from 'vue-i18n';
import { useCommon } from '@/store/useCommon';
import { ElMessageBox } from 'element-plus';
import { messageBox } from '@/utils/validate';
import { getCurrentTime } from '@/utils/timeFormat';
import { RELEASE_COLOR_NEW, RELEASE_STATUS_NEW, childModeOptions } from '@/assets/config/dicts';
import { removePropertyOfNull } from '@/utils/tools';
import { getProgramSetListApi, programSetStatusApi, getProgramRelationCategoryApi, exportProgramSetApi, deleteProgramSetApi, getCloudDiskOptionsApi } from '@/api/vodNew';
import BatchLinkCloudDisk from '@/views/onDemandContent/Components/batchLinkCloudDisk.vue';
import { getSysDictListApi } from '@/api/live';
const __default__ = {
  name: 'SeriesFilm'
};
export default /*#__PURE__*/_defineComponent({ ...__default__,

  setup(__props) {
    const {
      t
    } = useI18n();
    const tableRef = ref();
    const resonFormRef = ref();
    const tableWarpRef = ref();
    const cloudDiskOptions = ref();
    const vodCategoryList = ref([]); // 是否为VNO账号

    const isVnoUser = computed(() => useCommon().userData.roles.includes('VNO') || useCommon().userData.roles.includes('VNO_CMS'));
    const CODING_STATUS = {
      0: 'H.264',
      1: 'H.265'
    };
    const batchTable = reactive({
      visible: false
    });
    const addOrEdit = reactive({
      visible: false
    });
    const seriesLists = reactive({
      visible: false
    });
    const check = reactive({
      visible: false
    });
    const relevanceInfoDialog = reactive({
      visible: false
    });
    const cloudDiskDialog = ref({
      visible: false,
      data: null,
      programType: 'movie'
    });
    const data = reactive({
      languageOptions: [],
      detailInfo: {
        id: '',
        releaseStatus: ''
      },
      postData: {
        reason: ''
      }
    });

    const validatorReason = (rule, value, callback) => {
      if (value && value.trim() == '') {
        return callback(new Error('输入不能为空'));
      }

      callback();
    };

    const dialogConfig = reactive({
      visible: false,
      action: 'online',
      config: {
        title: '提示'
      },
      confirm: done => {
        if (dialogConfig.action === 'online') {
          programSetStatus('online', done);
        } else {
          resonFormRef.value.validate(valid => {
            if (valid) {
              programSetStatus(dialogConfig.action, done);
            }
          });
        }
      }
    }); // 搜索查询用额外到的参数

    const searchData = reactive({
      releaseStatus: '',
      categoryIds: [],
      sortType: '',
      sortField: ''
    });
    const searchConfig = reactive({
      size: {
        sm: 24,
        md: 12,
        lg: 8,
        xl: 6,
        xs: {}
      },
      formList: [{
        label: '品牌',
        prop: 'cid',
        widgetType: 'Select',
        filterable: true,
        placeholder: '请选择品牌',
        labelKey: 'prefixName',
        valueKey: 'cid',
        list: [],
        change: val => {
          searchData.categoryIds = [];
          sessionStorage.setItem('currentCid', val);
          searchConfig.formData.operatingUser = '';
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getUserByCid({
            cid: val
          });
        },
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_SF_BS') > -1;
        },
        disabled: useCommon().userData.roles.includes('VNO') || useCommon().userData.roles.includes('VNO_CMS')
      }, {
        label: '系列片名称',
        prop: 'keyword',
        widgetType: 'input',
        placeholder: '请输入关键字',
        maxlength: 50
      }, // {
      //    label: '分类属性', prop: 'genresId', widgetType: 'Select',
      //    placeholder: '请选择分类属性',
      //    labelKey: 'name', valueKey: 'id',
      //    list: [],
      //    change: (val) => {
      //     tableConfig.paginationConfig.page = 1;
      //     tableRef.value && tableRef.value.commonTableRef.clearSelection();
      //     getReviewList();
      //    }
      // },
      {
        label: '云盘账号',
        prop: 'cloudDiskId',
        widgetType: 'Select',
        list: cloudDiskOptions,
        labelKey: 'username',
        valueKey: 'id',
        change: val => {
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        }
      }, {
        label: '编码协议',
        prop: 'videoCode',
        widgetType: 'Select',
        list: [{
          label: t('全部'),
          value: ''
        }, {
          label: 'H.264',
          value: 'H264'
        }, {
          label: 'H.265',
          value: 'H265'
        }],
        change: val => {
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        }
      }, {
        label: '创建时间',
        prop: 'time',
        widgetType: 'date',
        'start-placeholder': t('开始时间'),
        'end-placeholder': t('结束时间'),
        valueFormat: 'YYYY-MM-DD',
        type: 'daterange',
        change: debounce(val => {
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        }, 200)
      }, {
        label: '操作用户',
        prop: 'operatingUser',
        widgetType: 'Select',
        filterable: true,
        placeholder: '',
        labelKey: 'name',
        valueKey: 'id',
        list: [],
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_OU') > -1;
        },
        change: val => {
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        }
      }, {
        label: '运营商',
        prop: 'cpspId',
        widgetType: 'treeSelect',
        list: [],
        filterable: true,
        // clearable: true,
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1;
        },
        change: val => {
          sessionStorage.setItem('currentCpspid', val);
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        }
      }, {
        label: '归属模式',
        prop: 'childMode',
        widgetType: 'Select',
        list: [{
          label: t('全部'),
          value: ''
        }, ...childModeOptions]
      }, {
        label: '内容分类',
        prop: 'categoryType',
        widgetType: 'Select',
        list: vodCategoryList
      }],
      formData: {
        // cid: Number(sessionStorage.getItem('currentCid')),
        cid: null,
        keyword: '',
        time: '',
        videoCode: '',
        operatingUser: '',
        cpspId: null,
        genresId: '',
        cloudDiskId: '',
        childMode: '',
        categoryType: ''
      }
    });
    const tableConfig = reactive({
      viewLoading: false,
      data: [],
      isCardBlock: true,
      paginationConfig: usePageConfig(),
      isShowHeader: false,
      scrollbarAlwaysOn: true,
      headerButtonsList: [{
        label: '关联云盘',
        func: () => {
          if (selectTableConfig.selectData.length === 0) {
            return elMessage('warning', '先勾选需要批量操作的影片');
          }

          cloudDiskDialog.value.visible = true;
          cloudDiskDialog.value.programType = 'video_series';
          cloudDiskDialog.value.data = selectTableConfig.selectData.map(item => item.id);
        }
      }, {
        label: '导出',
        func: () => {
          exportData();
        }
      }, {
        label: '批量操作',
        func: () => {
          const stateArr = selectTableConfig.selectData.map(item => item.releaseStatus);
          const hasSameValue = Array.from(new Set(stateArr)).length === 1;

          if (selectTableConfig.selectData.length === 0) {
            return elMessage('warning', '请先勾选需要批量操作的影片');
          } else if (!hasSameValue) {
            return elMessage('warning', '请先勾选状态相同的影片');
          } else {
            batchTable.visible = true;
          }
        },
        controller: config => {
          config.disabled = !selectTableConfig.selectData.length ? true : false;
          return true;
        }
      }, {
        label: '删除',
        type: 'danger',
        func: () => {
          if (selectTableConfig.selectData.length === 0) {
            return elMessage('warning', '请先勾选需要删除的影片');
          } else {
            deleteVodInfo();
          }
        },
        controller: config => {
          config.disabled = !selectTableConfig.selectData.length ? true : false;
          return true;
        }
      }, {
        label: '新增',
        func: () => {
          data.detailInfo = {
            id: '',
            releaseStatus: ''
          };
          addOrEdit.visible = true;
        }
      }, {
        label: '',
        cellSlot: true,
        func: () => {}
      }],
      maxHeight: '420px',
      'row-key': row => {
        return row.id;
      }
    });
    const columnConfig = reactive({
      columnList: [{
        label: '',
        prop: '',
        type: 'selection',
        'reserve-selection': true
      }, {
        label: '系列片名称',
        prop: 'name',
        minWidth: 230,
        sortable: 'custom'
      }, {
        label: '上线状态',
        prop: 'releaseStatus',
        cellSlot: true,
        minWidth: 160,
        sortable: 'custom'
      }, {
        label: '编码协议',
        prop: 'videoCode',
        minWidth: 120,
        sortable: 'custom' // formatter: (value: any) => {
        //   if (value) {
        //     let arr = value.split(',');
        //     const res = arr.map(item => CODING_STATUS[Number(item)]);
        //     return res.join();
        //   }
        // }

      }, {
        label: '节目数',
        prop: 'count',
        width: 160,
        sortable: 'custom'
      }, {
        label: '关联信息',
        prop: 'info',
        width: 130,
        cellSlot: true,
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_AT') > -1;
        }
      }, {
        label: '内容分类',
        prop: 'categoryType',
        minWidth: 160,
        sortable: 'custom'
      }, {
        label: '归属模式',
        prop: 'childMode',
        sortable: 'custom',
        width: 130,
        formatter: val => {
          if (val == null) return '';
          return val == 1 ? t('儿童模式') : t('常规模式');
        }
      }, {
        label: '操作用户',
        prop: 'operatorName',
        minWidth: 160,
        sortable: 'custom'
      }, {
        label: '创建时间',
        prop: 'createTime',
        minWidth: 170,
        sortable: 'custom',
        formatter: val => val && getCurrentTime(val)
      }, {
        label: '操作',
        prop: '',
        widgetType: 'buttons',
        fixed: 'right',
        width: 260,
        showOverflowTooltip: false,
        buttonsList: [{
          label: '查看',
          func: row => {
            const {
              id,
              releaseStatus
            } = row;
            data.detailInfo = {
              id,
              releaseStatus
            };
            check.visible = true;
          }
        }, {
          label: '编辑',
          func: row => {
            const {
              id,
              releaseStatus
            } = row;
            data.detailInfo = {
              id,
              releaseStatus
            };
            addOrEdit.visible = true;
          },
          controller: row => {
            return row.releaseStatus === 'online' ? false : true;
          }
        }, {
          label: '上线',
          func: row => {
            const {
              id
            } = row;
            auditParams.id = id;
            dialogConfig.action = 'online';
            dialogConfig.visible = true;
          },
          controller: row => {
            return row.releaseStatus !== 'online' ? true : false;
          }
        }, {
          label: '下线',
          func: row => {
            const {
              id
            } = row;
            auditParams.id = id;
            dialogConfig.action = 'offline';
            dialogConfig.visible = true;
          },
          controller: row => {
            return row.releaseStatus === 'online' ? true : false;
          }
        }, {
          label: '列表',
          func: row => {
            const {
              id,
              releaseStatus
            } = row;
            data.detailInfo = {
              id,
              releaseStatus
            };
            seriesLists.visible = true;
          }
        }, {
          label: '删除',
          func: row => {
            const {
              releaseStatus
            } = row;

            if (releaseStatus === 'online') {
              ElMessageBox.confirm(t('该影片已上线，需要先下线才能删除。'), t('Warning'), {
                confirmButtonText: t('确定'),
                cancelButtonText: t('取消'),
                type: 'warning'
              });
            } else {
              messageBox('确定删除这条数据吗?').then(async () => {
                try {
                  tableConfig.viewLoading = true;
                  const {
                    id
                  } = row;
                  const {
                    code
                  } = await deleteProgramSetApi([id]);

                  if (code == '0') {
                    elMessage('success', '删除成功');
                    getReviewList();
                  } else {
                    tableConfig.viewLoading = false;
                  }
                } catch (error) {
                  tableConfig.viewLoading = false;
                }
              });
            }
          },
          controller: row => {
            return row.releaseStatus === 'online' ? false : true;
          }
        }]
      }]
    }); // 系列影片上下线

    const programSetStatus = async (releaseStatus, done) => {
      try {
        let params = {
          videoSeriesId: auditParams.id,
          offlineReason: data.postData.reason.trim(),
          releaseStatus
        };
        const res = await programSetStatusApi([params]);

        if (res.code == '0') {
          elMessage('success', '操作成功');
          resonFormRef.value && resonFormRef.value.resetFields();
          dialogConfig.visible = false;
          getReviewList();
          setTimeout(() => {
            done();
          }, 500);
        } else {
          done();
        }
      } catch (error) {
        done();
      }
    };

    watch(() => dialogConfig.visible, val => {
      resonFormRef.value && resonFormRef.value.resetFields();
    }); // 批量删除按钮点击事件

    const deleteVodInfo = () => {
      let msgArr = [];
      let isReturn = false;
      let ids = [];
      selectTableConfig.selectData.forEach(item => {
        if (item.releaseStatus === 'online') {
          isReturn = true;
          msgArr.push(item.name);
        }

        ids.push(item.id);
      });

      if (isReturn) {
        return ElMessageBox.confirm(t('影片名已上线:', {
          list: msgArr.join(',')
        }), t('Warning'), {
          confirmButtonText: t('确定'),
          cancelButtonText: t('取消'),
          type: 'warning'
        });
      } else {
        messageBox('确定删除所选数据吗?').then(async () => {
          try {
            tableConfig.viewLoading = true;
            const res = await deleteProgramSetApi(ids);

            if (res.code == '0') {
              elMessage('success', '删除成功');
              tableRef.value && tableRef.value.commonTableRef.clearSelection();
              getReviewList();
            } else {
              tableConfig.viewLoading = false;
            }
          } catch (error) {
            tableConfig.viewLoading = false;
          }
        });
      }
    }; // 单条审核请求数据


    const auditParams = reactive({
      id: ''
    });
    const selectTableConfig = reactive({
      selectData: [] // table已勾选的数据列表

    }); // table复选框点击事件

    const handleSelectionChange = val => {
      selectTableConfig.selectData = val;
    }; // 获取系列影片数据列表


    const getReviewList = async () => {
      try {
        !tableConfig.viewLoading ? tableConfig.viewLoading = true : '';
        let params = { ...searchData,
          pageNo: tableConfig.paginationConfig.page,
          pageSize: tableConfig.paginationConfig.limit,
          ...searchConfig.formData
        };

        if (params.time && params.time.length) {
          params.startTime = params.time[0];
          params.endTime = params.time[1];
          delete params.time;
        }

        const res = await getProgramSetListApi(removePropertyOfNull(params));

        if (res.code == '0') {
          tableConfig.data = res.data ? res.data : [];
          tableConfig.paginationConfig.total = res.total;
        }

        selectTableConfig.selectData.length && selectTableConfig.selectData.forEach(row => {
          tableRef.value.commonTableRef.toggleRowSelection(row, true);
        });
      } catch (error) {}

      tableConfig.viewLoading ? tableConfig.viewLoading = false : '';
    }; // 获取操作用户


    const getUserByCid = async params => {
      getReviewList();
      const res = await getUserByCidApi(params);

      if (res.code == '0') {
        let item = getItemByProp(searchConfig.formList, 'operatingUser');
        item.list = [{
          name: t('全部'),
          id: ''
        }, ...res.data.sort(function (a, b) {
          return a.name.trim().localeCompare(b.name.trim());
        })];
      }
    }; // 格式化运营商列表数据


    const formateOperatorOptions = list => {
      let newList = [];
      list.forEach((item, index) => {
        newList.push({
          value: item.id,
          label: item.name,
          children: item.children != null && item.children.length > 0 ? formateOperatorOptions(item.children) : null
        });
      });
      return newList;
    }; // 获取运营商


    const getOperatorList = async () => {
      if (useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1) {
        try {
          const res = await getOperatorNameListApi();

          if (res.code == '0') {
            let item = getItemByProp(searchConfig.formList, 'cpspId');
            item.list = formateOperatorOptions(res.data);
          }
        } catch (error) {}
      }

      let currentCpspid = useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1 ? sessionStorage.getItem('currentCpspid') : useCommon().userData.cpspid || 0;
      searchConfig.formData.cpspId = currentCpspid ? Number(currentCpspid) : useCommon().userData.cpspid || 0;
      sessionStorage.setItem('currentCpspid', String(searchConfig.formData.cpspId));
    };

    const brandsList = ref([]); // 获取品牌选项数据

    const getBrands = async () => {
      try {
        tableConfig.viewLoading = true;
        await getOperatorList();

        if (useCommon().userData.permissionKey.indexOf('DC_SF_BS') > -1) {
          const brands = await useBrandsByUser();
          let searchItem = getItemByProp(searchConfig.formList, 'cid');
          searchItem.list = brands;
          brandsList.value = brands;
          let cid = sessionStorage.getItem('currentCid');

          if (!cid) {
            sessionStorage.setItem('currentCid', isVnoUser.value ? useCommon().userData.cid[0] : brands[0].cid);
            cid = searchConfig.formData.cid = isVnoUser.value ? useCommon().userData.cid[0] : brands[0].cid;
          } else {
            searchConfig.formData.cid = Number(cid);
          }

          useCommon().userData.permissionKey.indexOf('DC_OU') > -1 ? getUserByCid({
            cid: cid || brands[0].cid
          }) : getReviewList();
        } else {
          let cid = useCommon().userData.cid[0] || 0;
          searchConfig.formData.cid = cid;
          sessionStorage.setItem('currentCid', cid);
          useCommon().userData.permissionKey.indexOf('DC_OU') > -1 ? getUserByCid({
            cid: cid
          }) : getReviewList();
        }
      } catch (error) {
        tableConfig.viewLoading = false;
      }
    };

    const getCloudDiskOptions = async () => {
      const {
        code,
        data
      } = await getCloudDiskOptionsApi({
        name: useCommon().userData.name
      });

      if (code == 0) {
        cloudDiskOptions.value = data ? [{
          id: '',
          username: t('全部')
        }, {
          id: -1,
          username: t('未关联')
        }, ...data] : [];
      }
    };

    provide('brandsList', brandsList);
    onMounted(() => {
      getCloudDiskOptions();
      getBrands();
      getVodProCategoryAttributes();
      getAllLanguages();
    }); // 获取所有语言

    const getAllLanguages = async () => {
      const res = await useVodLanguages();
      data.languageOptions = res;
    };

    provide('languageOptions', data.languageOptions);
    const Tags = ref([{
      type: '',
      name: '全部'
    }, {
      type: 'online',
      name: '已上线'
    }, {
      type: 'not_online',
      name: '未上线'
    }, {
      type: 'offline',
      name: '已下线'
    }]); // 处理 tags 点击事件

    const handleTagClick = tag => {
      if (searchData.releaseStatus == tag.type) return;
      tableRef.value && tableRef.value.commonTableRef.clearSelection();
      tableConfig.paginationConfig.page = 1;
      searchData.releaseStatus = tag.type;
      getReviewList();
    }; // 搜索查询


    const handleSearch = searchData => {
      tableRef.value && tableRef.value.commonTableRef.clearSelection();
      getReviewList();
    }; // 重置


    const handleReset = () => {
      tableRef.value && tableRef.value.commonTableRef.clearSelection();
      tableRef.value && tableRef.value.commonTableRef.clearSort();
      searchData.categoryIds = [];
      searchData.sortType = '';
      searchData.sortField = '';
      tableConfig.paginationConfig.page = 1;
      searchConfig.formData = {
        cid: Number(sessionStorage.getItem('currentCid')),
        keyword: '',
        time: '',
        videoCode: '',
        operatingUser: '',
        cpspId: Number(sessionStorage.getItem('currentCpspid')),
        genresId: '',
        cloudDiskId: '',
        childMode: '',
        categoryType: ''
      };
      getReviewList();
    }; // 导出


    const exportData = debounce(async () => {
      if (tableConfig.data.length > 0) {
        try {
          tableConfig.viewLoading = true;
          let params = {
            cid: Number(sessionStorage.getItem('currentCid')),
            ...searchData,
            ...searchConfig.formData
          };

          if (selectTableConfig.selectData.length > 0) {
            const ids = selectTableConfig.selectData.map(item => item.id);
            params.videoSeriesIdList = ids;
          }

          const res = await exportProgramSetApi(removePropertyOfNull(params));
          fileDownload(res.data, res.processData.fileName, res.processData.contentType);
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
        } catch (error) {}

        tableConfig.viewLoading = false;
      }
    }, 500);

    const updateList = () => {
      // 清空table复选框选中
      tableRef.value && tableRef.value.commonTableRef.clearSelection();
      getReviewList();
    }; // 表格排序


    const handleSortChange = debounce(async params => {
      if (params.order) {
        const sortType = params.order.replace('ending', '');
        searchData.sortType = sortType;
        searchData.sortField = params.prop;
        getReviewList();
      } else {
        searchData.sortType = '';
        searchData.sortField = '';
        getReviewList();
      }
    }, 300);
    const infoTreeData = ref([]); // 关联信息item点击事件

    const relevanceInfoClick = async row => {
      infoTreeData.value = [];

      try {
        let params = {
          programId: row.id,
          programType: 'video_series'
        };
        const res = await getProgramRelationCategoryApi(params);

        if (res.code == '0') {
          infoTreeData.value = res.data;
        }
      } catch (error) {}

      relevanceInfoDialog.visible = true;
    };

    const setOptionsBtnColumnWidth = width => {
      const findItem = columnConfig.columnList.find(item => item.label == '操作');
      findItem ? findItem.width = width : '';
    };

    const filterColumnItemChange = () => {
      nextTick(() => {
        tableRef.value && tableRef.value.commonTableRef.doLayout();
      });
    };

    const getVodProCategoryAttributes = async () => {
      try {
        const {
          code,
          data
        } = await getSysDictListApi('vod_pro_type');

        if (code == 0) {
          vodCategoryList.value = data ? [{
            label: t('全部'),
            value: ''
          }, ...data] : [];
        }
      } catch (error) {}
    };

    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _component_TableColumnOptionBtn = _resolveComponent("TableColumnOptionBtn");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_MDialog = _resolveComponent("MDialog");

      const _directive_crosswiseScroll = _resolveDirective("crosswiseScroll");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_search_form, {
        size: searchConfig.size,
        gutter: 30,
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: handleSearch,
        onReset: handleReset
      }, null, 8, ["size", "form-list", "form-data"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(TagType, {
        modelValue: Tags.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => Tags.value = $event),
        onOnTagClick: handleTagClick
      }, null, 8, ["modelValue"]), _createVNode(Buttons, {
        class: "header__btns",
        "buttons-list": tableConfig.headerButtonsList
      }, {
        cellSlot: _withCtx(scope => [_createVNode(_component_TableColumnOptionBtn, {
          "column-list": columnConfig.columnList,
          onFilterColumnItemChange: filterColumnItemChange
        }, null, 8, ["column-list"])]),
        _: 1
      }, 8, ["buttons-list"])])), [[_directive_crosswiseScroll]]), !seriesLists.visible ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "table-list",
        ref_key: "tableWarpRef",
        ref: tableWarpRef
      }, [_createVNode(_component_common_table, {
        dynamicTableMaxHeight: "",
        pageSizesConfig: [10, 20, 40, 100, 200],
        dynamicOption: "",
        onSetOptionsBtnColumnWidth: setOptionsBtnColumnWidth,
        ref_key: "tableRef",
        ref: tableRef,
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        render: getReviewList,
        onSelectionChange: handleSelectionChange,
        onSortChange: _unref(handleSortChange)
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, {
          cellSlot: _withCtx(scope => [scope.column.property == 'releaseStatus' ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "text-overflow",
            style: _normalizeStyle('color:' + _unref(RELEASE_COLOR_NEW)[scope.row.releaseStatus])
          }, _toDisplayString(_unref(RELEASE_STATUS_NEW)[scope.row.releaseStatus]), 5)) : _createCommentVNode("", true), scope.column.property == 'info' ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "link",
            onClick: $event => relevanceInfoClick(scope.row)
          }, _toDisplayString(_ctx.$t('信息')), 9, _hoisted_5)) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "pagination-config", "onSortChange"])], 512)) : _createCommentVNode("", true)])])])), [[_directive_loading, tableConfig.viewLoading], [_vShow, !addOrEdit.visible && !batchTable.visible && !seriesLists.visible && !check.visible]]), _createVNode(AddOrEdit, {
        modelValue: addOrEdit.visible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => addOrEdit.visible = $event),
        "detail-info": data.detailInfo,
        onUpdateList: updateList
      }, null, 8, ["modelValue", "detail-info"]), _createVNode(BatchTable, {
        modelValue: batchTable.visible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => batchTable.visible = $event),
        "select-list": selectTableConfig.selectData,
        onUpdateList: updateList,
        "page-limit": tableConfig.paginationConfig.limit
      }, null, 8, ["modelValue", "select-list", "page-limit"]), _createVNode(SeriesLists, {
        modelValue: seriesLists.visible,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => seriesLists.visible = $event),
        "detail-info": data.detailInfo,
        onUpdateList: updateList
      }, null, 8, ["modelValue", "detail-info"]), _createVNode(Check, {
        modelValue: check.visible,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => check.visible = $event),
        "detail-info": data.detailInfo,
        onUpdateList: updateList
      }, null, 8, ["modelValue", "detail-info"]), _createVNode(RelevanceInfoDialog, {
        modelValue: relevanceInfoDialog.visible,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => relevanceInfoDialog.visible = $event),
        "info-tree-data": infoTreeData.value
      }, null, 8, ["modelValue", "info-tree-data"]), _createVNode(BatchLinkCloudDisk, {
        modelValue: cloudDiskDialog.value.visible,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => cloudDiskDialog.value.visible = $event),
        selectedChannel: cloudDiskDialog.value.data,
        programType: cloudDiskDialog.value.programType,
        onUpdateList: updateList
      }, null, 8, ["modelValue", "selectedChannel", "programType"]), _createVNode(_component_MDialog, {
        autoLoading: "",
        modelValue: dialogConfig.visible,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => dialogConfig.visible = $event),
        nativeConfig: {
          width: '25%',
          closeOnClickModal: false
        },
        dialogConfig: dialogConfig.config,
        onOnConfirm: dialogConfig.confirm
      }, {
        default: _withCtx(() => [dialogConfig.action === 'offline' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('确认将影片修改为下线吗?')), 1), _createVNode(_component_el_form, {
          model: data.postData,
          ref_key: "resonFormRef",
          ref: resonFormRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "reason",
            rules: [{
              validator: validatorReason,
              trigger: 'blur'
            }, {
              max: 100,
              message: _ctx.$t('限制字符数量', {
                num: '100'
              }),
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              style: {
                "width": "100%"
              },
              placeholder: _ctx.$t('请输入下线原因'),
              maxlength: 100,
              modelValue: data.postData.reason,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => data.postData.reason = $event),
              "show-word-limit": "",
              type: "textarea"
            }, null, 8, ["placeholder", "modelValue"])]),
            _: 1
          }, 8, ["rules"])]),
          _: 1
        }, 8, ["model"])], 64)) : _createCommentVNode("", true), dialogConfig.action === 'online' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode(_toDisplayString(_ctx.$t('确认将影片修改为上线吗?')), 1)], 64)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"])], 64);
    };
  }

});